import type { AifiLevel } from '@/domains/pages/ai-proficiency/constants';

export type OrgScoreBenchmarks = {
  median: number;
  topQuartile: number;
};

export type LevelBenchmarkShare = {
  topQuartileShare: number;
};

export type TrendBenchmarkPoint = {
  median: number;
  percentile25: number;
  percentile75: number;
};

/**
 * Static peer-group placeholders for the AI Proficiency page.
 * Replace with API-backed values when peer benchmarks are available.
 */

/** Power bar + over-time benchmark median line. */
export const STATIC_ORG_SCORE_BENCHMARK_MEDIAN = 54;

/** Power bar 75th-percentile marker. */
export const STATIC_ORG_SCORE_TOP_QUARTILE = 66;

export const STATIC_ORG_SCORE_BENCHMARKS: OrgScoreBenchmarks = {
  median: STATIC_ORG_SCORE_BENCHMARK_MEDIAN,
  topQuartile: STATIC_ORG_SCORE_TOP_QUARTILE,
};

/** Flat peer band for every over-time bucket (25th / median / 75th). */
export const STATIC_PEER_TREND_BENCHMARK_POINT: TrendBenchmarkPoint = {
  median: STATIC_ORG_SCORE_BENCHMARK_MEDIAN,
  percentile25: 46,
  percentile75: STATIC_ORG_SCORE_TOP_QUARTILE,
};

/** Per-level top-quartile share on the proficiency ladder. */
export const STATIC_LEVEL_TOP_QUARTILE_SHARE: Record<AifiLevel, number> = {
  Expert: 6,
  Practitioner: 48,
  Beginner: 30,
  Novice: 10,
};

export const STATIC_LEVEL_BENCHMARKS: Record<AifiLevel, LevelBenchmarkShare> = {
  Expert: { topQuartileShare: STATIC_LEVEL_TOP_QUARTILE_SHARE.Expert },
  Practitioner: { topQuartileShare: STATIC_LEVEL_TOP_QUARTILE_SHARE.Practitioner },
  Beginner: { topQuartileShare: STATIC_LEVEL_TOP_QUARTILE_SHARE.Beginner },
  Novice: { topQuartileShare: STATIC_LEVEL_TOP_QUARTILE_SHARE.Novice },
};

/** Align static trend placeholders to the org score time-series length. */
export function getStaticTrendBenchmarks(length: number): TrendBenchmarkPoint[] {
  if (length <= 0) return [];
  return Array.from({ length }, () => STATIC_PEER_TREND_BENCHMARK_POINT);
}
